'use client';

import { produce } from 'immer';
import { FC, ReactNode } from 'react';

import { storeFactory } from './storeFactory';

interface PlpFilterModalStoreStateData {
  isOpen: boolean;
}

interface PlpFilterModalStoreStateFunctions {
  setOpen: (value: boolean) => void;
}

const {
  store: plpFilterModalStore,
  StoreProvider: PlpFilterModalStoreProvider,
  useCreateStore: useCreatePlpFilterModalStore,
} = storeFactory<PlpFilterModalStoreStateData, PlpFilterModalStoreStateFunctions>(
  () => ({
    isOpen: false,
  }),
  (set) => ({
    setOpen: (value: boolean) => {
      set((state) =>
        produce(state, (draft) => {
          draft.isOpen = value;
        }),
      );
    },
  }),
);

export { plpFilterModalStore };

export const PlpFilterModalStore: FC<{ children: ReactNode }> = ({ children }) => {
  const createPlpFilterModalStore = useCreatePlpFilterModalStore({});

  return <PlpFilterModalStoreProvider createStore={createPlpFilterModalStore}>{children}</PlpFilterModalStoreProvider>;
};
